import { createFileRoute } from '@tanstack/react-router';
import { GanttView } from '@/features/tasks/GanttView';

export const Route = createFileRoute('/_app/tasks/gantt')({ component: GanttView });
